export const SECURITY_ACTIONS = {
  EDIT: 'edit',
  APPROVE: 'approve',
  PUBLISH: 'publish'
};
